(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cookie-consent"]) return;
  try {
    
  (() => {
    const banner = document.querySelector('[data-cookie-consent]');
    if (!banner || !window.Shopify?.loadFeatures) return;
    Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      const privacy = window.Shopify?.customerPrivacy;
      if (error || !privacy) return;
      const consent = privacy.currentVisitorConsent();
      const undecided = [consent.analytics, consent.marketing, consent.preferences].every(value => value === '');
      if (privacy.shouldShowBanner() || undecided) banner.hidden = false;
      const save = value => {
        privacy.setTrackingConsent({ analytics: value, marketing: value, preferences: value }, () => {
          banner.hidden = true;
        });
      };
      banner.querySelector('[data-cookie-accept]')?.addEventListener('click', () => save(true));
      banner.querySelector('[data-cookie-reject]')?.addEventListener('click', () => save(false));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-policy-open]');
    if (trigger) {
      document.querySelector(`[data-policy-dialog="${trigger.dataset.policyOpen}"]`)?.showModal();
    }
    if (event.target.matches('[data-policy-dialog]')) {
      event.target.close();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-quantity-decrease], [data-quantity-increase]');
    if (!button) return;
    const stepper = button.closest('.quantity-stepper');
    const input = stepper.querySelector('[data-quantity-input]');
    const output = stepper.querySelector('output');
    const delta = button.hasAttribute('data-quantity-increase') ? 1 : -1;
    const quantity = Math.max(0, Number(input.value) + delta);
    input.value = quantity;
    output.textContent = quantity;
    button.closest('[data-cart-form]').requestSubmit();
  });

  } catch(e) { console.error(e); }
})();
})();
